import { Inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@shared/providers/environment.provider';
import { Environment } from '../../types/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  constructor(@Inject(APP_ENVIRONMENT) private readonly env: Environment) {}

  getApiUrl() {
    return this.env.apiUrl;
  }

  getWebsocketUrl() {
    return this.env.websocketUrl;
  }
}
